import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [loading, setLoading] = React.useState(false);
  async function fetchData() {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/authenticate`,
        {
          withCredentials: true,
        },
      );
      setLoggedInUser(response.data.loggedInUser);
    } catch (err) {
      setLoggedInUser(null);
      navigate("/login");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const [notification, setNotification] = useState({
    open: false,
    color: "success",
    message: "",
  });

  const login = async (values) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/login`,
        {
          username: values.username,
          password: values.password,
        },
        {
          withCredentials: true,
        },
      );

      setLoggedInUser(response.data.username);
      setLoading(false);
      setNotification({
        open: true,
        color: "success",
        message: response.data.message,
      });
      navigate("/dashboard");
    } catch (error) {
      console.error(error);
      setNotification({
        open: true,
        color: "error",
        message: error.response.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/logout`,
        {
          withCredentials: true,
        },
      );
      setLoggedInUser(null);
      setLoading(false);
      setNotification({
        open: true,
        color: "success",
        message: response.data.message,
      });
      navigate("/login", { replace: true });
    } catch (error) {
      console.error(error);
      setNotification({
        open: true,
        color: "error",
        message: error?.response.data?.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user: loggedInUser,
        setLoggedInUser,
        loading,
        setLoading,
        notification,
        setNotification,
        login,
        logout,
        isAuthenticated: !!loggedInUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.context = AuthContext;

export const useAuthContext = () => useContext(AuthContext);
